import { types } from "../types/types";

export const setAlreadyEnterInWizard = (value) => ({
    type: types.wizardSetAlreadyEnterInWizard,
    payload: value,
});
